import React, {useEffect, useState, useContext} from 'react'
import Products from '../ProductCarousal1/Products';
import { useCart } from '../AddToCart/CartContext';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../HomePage/Home.css';
import './Viewallproducts.css'
import { useAuth } from '../firebase/AuthContext';

import { DataContext } from "../ProductCarousal1/DataProvider";
import { useSelector } from "react-redux";
import Skeleton from '@mui/material/Skeleton';
import CustomerCare from '../CustomerCare/CustomerCare';
import CartDrawer from '../AddToCart/CartDrawer';

export default function OurCollection() {
const {loading, loadingMore, loadMoreOurCollection, } = useContext(DataContext);

  const {ourCollection}= useSelector(
    (state) => state.ourCollection
    );
    // const {homeImprovement}= useSelector(
    //   (state) => state.homeImprovement
    //   );

    const [isCartOpen, setIsCartOpen] = useState(false);
            
    // Function to open the cart drawer
    const handleAddToCart = () => {
      setIsCartOpen(true);
    };


  // Effect to automatically load more products when reaching the bottom of the page (optional)
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMoreOurCollection();
        }
      },
      { threshold: 1.0 }
    );

    // const bottomElectronicCollection = document.getElementById("electronicCollection-bottom");

    // if (bottomElectronicCollection) observer.observe(bottomElectronicCollection);

    // return () => {
    //   if (bottomElectronicCollection) observer.unobserve(bottomElectronicCollection);
    // };
  }, [loading, loadingMore]);



    const OurcollectionallProducts = [...ourCollection];
    // const ElectronicscollectionallProducts = [...electronicCollection];
    const { addToCart} = useCart();

    //after successful login Redirect user current page mean as it is previous page
    const navigate = useNavigate();

    //Page Showing start from top
    //after successful login Redirect user current page mean as it is previous page
    const location = useLocation();



    //Page Showing start from top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); 
    //Page Showing start from top

     //after successful login Redirect user current page mean as it is previous page
    const handleLoginNavigate = () => {
    // console.log("Attempting to navigate to /login")
    navigate('/login', { state: { from: location.pathname } });
    };
    const { handleUserNavigation } = useAuth();
    //after successful login Redirect user current page mean as it is previous page

  return (
    <>
        <h2 className='collection-heading'>Earbuds Collection</h2>
        <div className="view-all-products">
            {OurcollectionallProducts.map((item) => (
                <Products
                    key={item.id}
                    id={item.id}
                    name={item.name}
                    title={item.title}
                    imageUrl={item.imageUrl}
                    price={item.price}
                    discountPrice={item.discountPrice}
                    description={item.description}
                    addToCart={addToCart}
                    quantity={item.quantity}
                    onAddToCart={handleAddToCart}
                />
            ))}
        </div>
        <CustomerCare />

        {/* Cart Drawer */}
        <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  )
}